import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import HeaderBase from "./HeaderBase";

const Header = () => {

	const { isMobile } = useSelector(state => state.general);

    return (

        <Routes>
            <Route  path='/' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/profile/*' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/checkout/cart' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/product' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/product/*' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/category/*' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/search/*' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/seller/*' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/best-selling' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/best-selling/*' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/amazing-offers' element={ !isMobile ? <HeaderBase /> : null} />
            <Route  path='/flash-sale' element={ !isMobile ? <HeaderBase /> : null} />
        </Routes>

    );
}

export default Header;